const en = {
  seo: {
    domov: {
      title: 'Judo Club Izola | Judo Obala – Izola, Koper, Ankaran, Portorož',
      description: 'Judo Club Izola – Iztok Babič Judo School. Judo for children and youth on the Slovenian Coast: Izola, Koper, Ankaran, Portorož. Over 30 years of tradition and Olympic champion Andreja Leški.',
      keywords: 'judo obala, judo koper, judo portoroz, judo ankaran, judo izola, judo club izola, judo school, judo for kids, Iztok Babič, Andreja Leški',
    },
    onas: {
      title: 'About us | Judo Club Izola – Iztok Babič Judo School',
      description: 'The story of Judo Club Izola: over 30 years of judo on the Coast, judo camps, literature and the road to Andreja Leški\'s Olympic gold in Paris 2024.',
      keywords: 'judo izola history, Iztok Babič judo school, judo camps izola, Andreja Leški, judo obala, judo koper',
    },
    galerija: {
      title: 'Gallery | Judo Club Izola',
      description: 'Photo moments of Judo Club Izola: training, competitions, judo camps and events with Olympic champion Andreja Leški.',
      keywords: 'judo izola gallery, judo camps, judo obala photos, Andreja Leški',
    },
    kontakt: {
      title: 'Schedule & contact | Judo Club Izola',
      description: 'Training schedule and contact for Judo Club Izola. Training in the Dante Alighieri Primary School gym in Izola. Judo for boys and girls on the Coast.',
      keywords: 'judo izola schedule, judo izola contact, judo obala, judo koper, judo ankaran, judo portoroz, judo enrolment 2026',
    },
    strokovna: {
      title: 'Professional knowledge | Judo Club Izola',
      description: 'Lectures, professional articles and historical perspectives by coach Iztok Babič on judo, the competitive philosophy of sport and Olympic tradition.',
      keywords: 'judo professional knowledge, Iztok Babič lecture, judo theory, history of sport, olympic games, judo obala',
    },
    kampi: {
      title: 'Camps and events | Judo Club Izola',
      description: 'Summer judo camps in Izola, international networking and the European Junior Judo Cup at the Bonifika Arena. Judo Club Izola.',
      keywords: 'judo camps izola, summer judo camp, european junior cup, Bonifika Arena, judo obala, judo koper',
    },
  },
  nav: {
    links: [
      { name: 'Home', path: '/' },
      { name: 'About us', path: '/o-nas' },
      { name: 'Gallery', path: '/galerija' },
      { name: 'Professional knowledge', path: '/strokovna-znanja' },
      { name: 'Camps & events', path: '/kampi-in-prireditve' },
      { name: 'Schedule & contact', path: '/kontakt' },
    ],
  },
  footer: {
    country: 'Slovenia',
    desc: 'Tradition, discipline and excellence in judo. Judo Club Izola is home to all generations of judoka.',
    navTitle: 'Navigation',
    contactTitle: 'Contact',
    address: 'Dante Alighieri Primary School, Izola',
    rights: 'All rights reserved.',
    school: 'Iztok Babič Judo School',
    areas: 'Judo for children and youth on the Slovenian Coast – Izola, Koper, Ankaran and Portorož.',
  },
  domov: {
    hero: {
      badge: 'Welcome',
      sub: 'Tradition, creativity and excellence in judo',
      ctaJoin: 'Join us',
      ctaNews: 'Read the news',
    },
    project: {
      label: 'Current project',
      title: 'Project Fit and Included',
      introBefore: 'Judo Club Izola participates as a partner in the project ',
      introHighlight: 'Fit and Included',
      introAfter: ', co-financed under the 2025 Public Call for the Development and Professionalisation of NGOs and Volunteering. The project is financed from the Fund for the Development of Non-Governmental Organisations.',
      bullets: [
        'Regular training for children and youth',
        'Judo promotion in primary schools',
        'Inclusion of immigrant children',
        'Individual mentoring',
        'Professional development of coaches',
        'Healthy lifestyle',
      ],
      note: 'Through this project we increase the accessibility of sport, encourage the inclusion of children and contribute to the development of quality sports programmes in the local community.',
    },
    newsLabel: 'News',
    news1: {
      title: 'Olympic champion Andrea Leški at Judo Club Izola – a training session you never forget!',
      p1: 'At Judo Club Izola we experienced an extraordinary sporting moment: Olympic champion Andrea Leški visited us and led a special training session for our members. The session was energetic, motivating and full of first-hand top-level advice – it was especially exciting for our young members, who got the chance to train with the very best and experience how an Olympic winner thinks and works.',
      p2: 'After the training we took group and individual photos with Andrea, and the club received a very special honour: Andrea also brought her Olympic medal, which our members could hold, examine up close and photograph themselves with. It was a moment of pride, inspiration and extra motivation for all generations.',
      quote: '"It was a moment of pride, inspiration and extra motivation for all generations."',
      p3: 'Alongside this important visit, the club is also celebrating a major development success. We were successful in a public call and signed a new contract, securing a project aimed at young people, their parents and the wider public. This is an important step forward that will strengthen our work in the local community and create new opportunities for sports participation, connection and a healthy lifestyle.',
      p4: 'In the evening we also held a working meeting of the project team, where we outlined the next steps and symbolically toasted the successful future of the club and the coach who will lead the project. All club members will stand by him, help him and make sure the project achieves its purpose.',
      closing: 'Thank you, Andrea, for the visit, the knowledge and the inspiration – days like these build the future of our club!',
      cta: 'View all photos',
    },
    news2: {
      title: 'We won silver at the Bežigrad Cup',
      p1: 'Both of our national champions in the younger girls category won an excellent second place: Jora Kuci and Diana Černec.',
      p2: 'The great success of our judo sports school was completed by Luka Angelini in the younger cadets, who also finished second. In the overall rankings of all competitions for younger cadets, Luka currently shares second place with Gal Purnat. Gal also finished second at the same competition, so both remain at the very top and continue to share the leading position.',
      p3: 'The other contenders were not as successful, so Luka and Gal have pulled slightly further ahead of them in points. This means that at the end of the ranking list they have a good chance of achieving at least the goal we set — a placement of at least second place.',
      quote: '"This is a good wind, perhaps just a gentle breeze for now, but it shows that our judo sports school is rising again and that we are once again achieving the results we used to produce."',
      p4: 'We sincerely congratulate all the competitors who achieved great placements on their success.',
      caption: 'In the photos: Diana and Jora at the medal ceremony - the medals were awarded by Olympic champion Andreja Leški. Third photo: Jora fighting her opponent.',
      cta: 'View all photos',
    },
    about: {
      label: 'About the club',
      titleTop: 'Judo school of',
      titleGold: 'Iztok Babič',
      text: 'Our school covers Izola, Koper and Ankaran – we connect three clubs with the same vision of excellence. Tradition, discipline and friendship are the foundations of our work.',
      cta: 'More about us',
    },
    enrollTeaser: {
      label: 'Enrolment 2026–2027',
      title: 'Enrol your child in judo',
      text: 'We are opening enrolment in our judo sports school for boys and girls. Check the training schedule and join us in the Dante Alighieri Primary School gym in Izola.',
      cta: 'See schedule & enrol',
    },
    cta: {
      title: 'Become part of our story',
      text: 'Join our club and start your journey in the world of judo. We welcome members of all ages and experience levels.',
      button: 'Contact us',
    },
  },
  galerija: {
    hero: {
      label: 'Gallery',
      title: 'Photo moments',
      sub: 'Moments we treasure. Training sessions, competitions and events that build our story.',
    },
    photosWord: 'photos',
    open: 'Open gallery',
    moreSoon: 'More events coming soon...',
    close: 'Close',
    prev: 'Previous',
    next: 'Next',
    events: {
      'poletje-na-tatamiju-2026': {
        title: 'Summer on the Tatami – 16 days of judo in Izola',
        description: 'Two summer judo camps, a visit from Olympic champion Andreja Leški, the first female black belt in the club and an interview for RTV Slovenia.',
        photos: [
          { title: 'Andreja Leški on the tatami', description: 'Olympic champion Andreja Leški during a training session with the young judoka at the camp' },
          { title: 'A tatami full of young judoka', description: 'Training of the younger age groups at the summer judo camp' },
          { title: 'Interview for RTV Slovenia', description: 'Our young member talking to an RTV Slovenia journalist' },
          { title: 'In front of the camera', description: 'Filming a television report about the summer judo camp' },
          { title: 'Group photo with Andreja Leški', description: 'Our young members with the Olympic champion and the club president' },
          { title: 'Master grade examination', description: 'Taking the master grade exam in front of the committee' },
          { title: 'Nina Jajić – 1st DAN', description: 'Coach Jaša Babič and Nina Jajić with her black belt diploma – the first female judo master in our club' },
        ],
      },
      'andreja-in-ekipa-2026': {
        title: 'Andreja Leški and Our Crew',
        description: 'Moments with Olympic champion Andreja Leški and our crew from the summer judo camp at the Bonifika Arena.',
        photos: [
          { title: 'Andreja and our crew', description: 'Our youngest members with Olympic champion Andreja Leški' },
          { title: 'Diana and Andreja demonstrating', description: 'Our Diana as the Olympic champion\'s partner during a technique demonstration' },
          { title: 'Izola Summer Judo Camp', description: 'The camp participants\' joint bow at the Bonifika Arena' },
          { title: 'Jaka at physiotherapy', description: 'Jaka needed physiotherapy care at the camp – that is taken care of too' },
        ],
      },
      'pokal-bezigrad-2024': {
        title: 'Bežigrad Cup 2024 - Silver success',
        description: 'We won silver at the Bežigrad Cup. Our national champions and young cadets achieved excellent results.',
        photos: [
          { title: 'Medal ceremony', description: 'Diana and Jora at the medal ceremony - the medals were awarded by Olympic champion Andreja Leški' },
          { title: 'Winners on the podium', description: 'Our young judoka on the winners podium' },
          { title: 'Jora in combat', description: 'Jora Kuci fighting her opponent' },
        ],
      },
      'andrea-leski-2024': {
        title: 'Olympic champion Andrea Leški at Judo Club Izola',
        description: 'A training session you never forget! Olympic champion Andrea Leški visited our club.',
        photos: [
          { title: 'Supervising practice', description: 'Andrea Leški supervising the members\' practice' },
          { title: 'Demonstration of an entry with off-balancing', description: 'Andrea Leški demonstrating technique' },
          { title: 'Grip demonstration', description: 'Demonstration of a judo grip' },
          { title: 'A successful example of off-balancing', description: 'Andrea demonstrating off-balancing' },
          { title: 'Group of younger judoka', description: 'Our young judoka after training' },
          { title: 'A toast to the success of the new project', description: 'Celebrating a successful project dedicated to young athletes' },
        ],
      },
    },
  },
  kontakt: {
    hero: {
      label: 'Contact',
      title: 'Get in touch',
      sub: 'Do you have questions? Want to learn more about membership? Contact us.',
    },
    infoTitle: 'Contact details',
    address: { title: 'Address', value: 'Dante Alighieri Primary School, Izola' },
    phone: { title: 'Phone', value: '+386 31 625 170', note: 'Iztok Babič' },
    email: { title: 'E-mail', value: 'iztok.babic8@gmail.com', note: 'Iztok Babič' },
    hours: { title: 'Training schedule', value: 'Tuesday & Thursday: 16.30–20.00 • Wednesday & Friday: 16.30–17.30' },
    locationsTitle: 'Our locations',
    locations: [
      { name: 'Izola', note: 'Dante Alighieri Primary School gymnasium – training and enrolment' },
      { name: 'Koper', note: 'Details will be added' },
      { name: 'Ankaran', note: 'Details will be added' },
    ],
    map: { title: 'Map', text: 'Dante Alighieri Primary School, Izola' },
    google: {
      label: 'Google',
      title: 'Find us on Google',
      text: 'Look up Judo Club Izola on Google Maps, check the location and leave us a review. Your feedback means a lot to us.',
      cta: 'Open in Google',
    },
    schedule: {
      label: 'Schedule',
      title: 'Weekly training schedule',
      text: 'Training schedule for all groups – kindergarten, younger, older, and veterans & recreation – in the Dante Alighieri Primary School gym.',
      imgAlt: 'Weekly training schedule of Judo Club Izola for all groups',
    },
    enroll: {
      label: 'Enrolment 2026–2027',
      title: 'Judo sports school for boys and girls',
      intro: 'We invite you to enrol in our judo sports school for the 2026–2027 season. Training and enrolment take place in the gymnasium of the Dante Alighieri Primary School.',
      rows: [
        { group: 'Pupils, grades 1–2', days: 'Tuesday and Thursday', time: '16.30–18.00' },
        { group: 'Pupils, grades 3–5', days: 'Tuesday and Thursday', time: '18.00–20.00' },
        { group: 'Judo kindergarten', days: 'Wednesday and Friday', time: '16.30–17.30' },
      ],
      note: 'Other training times can also be arranged at enrolment.',
      posterAlt: 'Judo sports school enrolment poster 2026–2027',
    },
    school: {
      label: 'Judo school',
      title: 'Iztok Babič Judo School',
      text: 'Our school operates in three locations: Izola, Koper and Ankaran. We connect three clubs with the same vision of excellence and a tradition of top-level judo.',
    },
  },
  kampi: {
    hero: {
      label: 'Camps and events',
      title: 'Camps, competitions and events',
      sub: 'Summer judo camps, international networking and upcoming events of Judo Club Izola.',
    },
    event: {
      badge: 'Event announcement',
      title: 'European Junior Judo Cup',
      date: 'End of November 2026',
      place: 'Bonifika Arena, Koper',
      text: 'Judo Club Izola and Judo Club Impol jointly participate in organising the European Junior Judo Cup at the Bonifika Arena. A detailed announcement with promotion will follow soon.',
      soon: 'Promotion coming soon',
    },
    cta: {
      title: 'Would you like to join us?',
      text: 'Contact us for more information about camps, training and events.',
      button: 'Contact us',
    },
  },
  strokovna: {
    hero: {
      label: 'Professional knowledge',
      title: 'Knowledge that builds champions',
      sub: 'Lectures, professional articles and historical perspectives by coach Iztok Babič.',
    },
    video: {
      label: 'Lecture',
      title: 'Excerpt from a lecture to JZS representatives (2011)',
      desc: 'On anticipation ("prečasnost") and its comparison with combat action. Coach Iztok Babič presents a professional view of anticipation and responsiveness in judo.',
    },
    docsLabel: 'Historical topics',
    docsTitle: 'Two historical topics',
    docs: [
      {
        title: 'Modern historical views on the competitive philosophy of sport',
        desc: 'The development of competitive sport and its philosophy from a judo perspective – from ancient roots to modern phenomena and the importance of judo for youth development. (Author: Iztok Babič)',
        meta: '9 pages · PDF',
        cta: 'Read the article',
      },
      {
        title: 'Young athletes in the ancient Olympic Games',
        desc: "The role of young athletes in the ancient Olympic Games, compared with today's Youth Olympic Games and the influence of politics on sport.",
        meta: '4 pages · PDF',
        cta: 'Read the article',
      },
    ],
    note: 'We will regularly add more professional materials.',
  },
  onas: {
    hero: {
      label: 'Judo Club Izola',
      title: 'About us',
      sub: 'A story of dedication, knowledge and development',
    },
    beginnings: {
      label: 'Beginnings',
      title: 'The first visual materials hinting at the beginnings can already be found in professional literature',
      p1: 'Judo Club Izola, at the time still under the name Sports Association Vitalis, began operating in 1998. That year the Dante Alighieri Primary School with Italian as the language of instruction opened, and in the same autumn the enrolment of judo beginners began.',
      imgCaption: 'Pictures from the book Judo for the Young, season 1999/2000',
      p2: 'Thus began the second school season, 1999/2000.',
      p3: 'Both pictures above were published in the book Judo for the Young, which was prepared in 2000 and published a year later, in 2001. This means the children were photographed in the 1999/2000 season, and the action took place in the gymnasium of the aforementioned school. On the right is coach Iztok Babič – in the upper picture preparing for a presentation, and in the lower one presenting a club competition in front of the first spectators, the parents, in an adapted judo/sumo bout for the youngest.',
      p4: 'Thus the history of judo in Izola was recorded in literature from its very first years, where the coach as an author conveys that combat is important for development from a very early age – provided, of course, that it is pedagogically adapted to the child\'s age. This is very well presented in the book.',
    },
    recognition: {
      label: 'Recognition',
      title: 'Efforts for the recognition of Judo Club Izola as a sports school of national importance',
      p: [
        'Coach Iztok Babič was co-financed within the aforementioned project through the Judo Club 15. maj Marezige and strove for this programme to cover all the judo clubs he organised. This was particularly important for Judo Club Izola, which participated in this programme.',
        'He therefore addressed a letter to the Ministry of Education and Sport, with which he had a signed contract, asking that his work in the other club be not only recognised but also formally regulated due to the non-compete clause, so that this work would not be disputed. He received a modest but positive reply to this letter.',
        'We can say that with this, Judo Club Izola\'s work with young people, including talented young members, was officially recognised. While this carried a certain prestige, what mattered most was that it was a recognition of quality and professionally sound work.',
      ],
      imgCaption: 'The ministry\'s reply to the letter, permitting professional work within the framework of the Sports School of National Importance.',
    },
    literature: {
      label: 'Literature',
      title: 'Success required rich literature – the first book was published',
      capCover: 'Judo for the Young – book cover from 2001.',
      capPages: 'Judo for the Young – inside contents, including pictures.',
      p: [
        'The book was co-financed by the Ministry of Education and Sport and the Foundation for Sport of the Republic of Slovenia. It was very rare for the ministry to co-finance such a book. But if we consider that in 1996 the Judo Federation proposed including judo in school sports competitions and wanted Iztok Babič to lead this, it may be one of the reasons why they supported his work.',
        'And that was not all. The Federation was also aware that in 1997 he was accepted as a coach at the Sports School of National Importance. All this eloquently shows that the coach\'s work had been noticed even earlier and that the state offered him opportunities for professional work with young people in judo. Soon afterwards, the literature we are presenting today was also published.',
      ],
      bold: 'And this is not the end. In what follows we briefly present the progress, crowned by the Olympic gold medal won in Paris 2024 by Andreja Leški, who enrolled in the Iztok Babič Sports School in the autumn of 2002.',
    },
    book2: {
      label: 'Continuation',
      title: 'Then came the second book',
      imgCaption: 'The book, published in 2010: above its front and back cover, below its contents.',
      p: [
        'The second book builds on the first book Judo for the Young, attempting to show the further development of professional work through a practical presentation of the 2009 European Cadet Championships, held at the Bonifika Arena in Koper.',
        'The message is twofold, or we can say it rests on two important pillars. First: from friendly initial pedagogical approaches in sports competitions for the youngest at club level to the biggest elite competitions for adolescents. The coach thus brought European competitions home and studied them practically on his own doorstep.',
        'Second: the coach connected all the professional science available in libraries, all the professional articles with laboratory research and their findings, into a new concept of explaining practice. In addition, he developed methods for using these insights to influence the even more effective development of a young person in sports training.',
      ],
      youthCaption: 'Izola youth in 2007: kneeling on the far right Andreja Leški, standing behind her, her constant companion at competitions, Lea Knez.',
    },
    kata: {
      label: 'Judo kata',
      title: 'Andreja Leški and Lea Knez - judo kata performance in 2011',
      kataCaption: 'Andreja Leški and Lea Knez - judo kata performance in 2011.',
      p: [
        'The Iztok Babič Sports School also introduced judo kata into training. In this field we were pioneers of development, which included participation in international meetings and seminars, organisation of international competitions, national championships and even two European championships, in 2013 and 2017, at the Koper Primary School.',
        'In 2012, Igor Albreht, who led this programme, achieved 3rd place in Prague, and coach Iztok Babič took over the flag as the next organiser.',
      ],
      flagCaption: 'Taking over the flag in Prague in 2012 at the European Judo Kata Championships, as the next organiser in 2013.',
    },
    lectures: {
      label: 'Education',
      title: 'Regular lectures',
      imgCaption: 'Regular lectures for parents and adolescents took place in the gymnasium of the Dante Alighieri Primary School in 2022.',
    },
    camps: {
      label: 'Judo camps',
      title: 'Summer judo camps in Izola',
      intro: [
        'For more than 30 years, the Izola Summer Judo Camp has been held regularly under the patronage of the Judo Federation of Slovenia, in which Judo Club Izola, as the home club, has played an important organisational role.',
        'Over the years, a regular family summer camp of judoka from Vienna has also developed. And since 2024, a third camp has been held – the Izola Summer TC Judo Camp, organised by Judo Club Izola.',
      ],
      campCaption: 'Education took place at all judo camps in Izola – the picture is from the gymnasium of the D. Alighieri Primary School. In the picture, first from the right, Slavko Obadov, the first judoka to win an Olympic medal for Yugoslavia, in 1976 in Montreal (Canada).',
      p1: 'At the camps, where practically all age groups participate, it is worth emphasising that among the participants are also the most elite judoka from all over Europe, including numerous Olympic medallists, even gold medallists. Let us mention just one – Ilias Iliadis, who won gold medals at the biggest competitions. In August 2013 he was with us, and at the end of the same month, at the twilight of his career, he won his last medal from major competitions – a bronze medal at the World Championships in Rio de Janeiro, Brazil.',
      livadeCaption: 'Izola Summer Judo Camp 2023 in the Livade Primary School hall, regularly attended by all young judoka from the Coast. In the second picture we also trained with Olympic champion Ilias Iliadis.',
    },
    tatami: {
      label: 'Summer on the Tatami',
      title: 'Izola – more than 30 years of judo camps, education, friendship and elite sport',
      intro: [
        'This summer once again confirmed Izola\'s important place on the map of Slovenian and international judo. With two consecutive judo camps we created no fewer than 16 days of intensive sports training, education, socialising and international networking.',
        'But the story of the Izola judo camps is much longer. It has been developing for more than three decades and over time has outgrown the framework of ordinary sports preparations. The camps have also become an important space for education, where knowledge and experience are passed on between coaches, competitors and generations.',
        'Young people here do not only learn techniques and combat. They learn alongside older and more experienced athletes, discover different ways of training, gain new experience and gradually build on their knowledge. At the same time, coaches also educate themselves, as the international environment enables the exchange of professional views, working methods and good practices.',
        'It is precisely education and the continuous transfer of knowledge that have been important building blocks of the development of young athletes for more than thirty years. The talented and persistent gradually progressed from younger categories to junior and senior judo, and some all the way to European, world and Olympic medals.',
        'That is why we do not understand our camps merely as sports preparations. They are a space of sports training and education, intergenerational knowledge transfer, friendship and international networking. It is precisely the interweaving of all these activities that has created an environment in which young people could progress over the years and achieve even the highest sporting goals.',
      ],
      s1: {
        title: 'The first camp – more than 30 years of tradition and international networking',
        p: [
          'The first international judo camp is jointly led by Judo Club Izola and Judo Club Impol. Its special feature is a tradition of more than thirty years, in which numerous foreign clubs have also played an important role. Some have been returning to Izola for more than three decades.',
          'In the development of this story, an important role was played by the home club, Judo Club Izola, which over the years ensured that the knowledge and experience of older coaches and competitors were not lost, but passed on to new generations.',
          'Young people trained alongside older and more successful competitors, observed them, learned from them and over time tried to catch up with them and even surpass them. The most talented, persistent and successful progressed to junior and senior categories, and some all the way to the biggest international competitions.',
          'Thus, over the decades, the camp has become an important building block of sports training and youth education.',
        ],
      },
      s2: {
        title: 'The knowledge of the first generation is not lost – the new one takes it over and builds on it',
        p: [
          'The special value of a tradition of more than thirty years lies precisely in the fact that the acquired knowledge is not lost with the arrival of new generations.',
          'The first generations of coaches and competitors gained experience through years of work, developed training methods and passed their knowledge on to the younger ones. These took it over, enriched it with their own experience and new professional insights, and then passed it on.',
          'Thus an unbroken developmental chain was formed: one generation lays the foundations, the next takes them over, upgrades them and develops them further.',
          'Young people who once learned from their elders at the camps later became top competitors, coaches and role models for the next generations themselves.',
        ],
        quote: 'It is precisely in this that we see one of the greatest values of our system: the new does not erase the old, but grows out of it and builds upon it.',
      },
      s3: {
        title: 'Friendship and international exchange of knowledge',
        p: [
          'Over the decades, the camps have connected not only generations, but also people from different countries.',
          'In Izola, athletes from Slovenia, Italy, Kosovo, Poland and many other places trained together. Coaches exchanged professional insights, working methods and good practices, while competitors got new partners and discovered different styles of judo.',
          'Along the way, friendships were formed that often lasted much longer than an individual camp. The very fact that some foreign clubs have been returning to Izola for more than thirty years shows best that a true international community has developed from sports cooperation.',
          'We did not keep knowledge to ourselves. We exchanged it, learned from one another and helped each other progress internationally.',
          'That is also why the Izola camp has, over the decades, become recognised in the wider European judo space.',
        ],
      },
      s4: {
        title: 'From young participants to Olympic medals',
        p: [
          'The results of such work do not show overnight.',
          'Behind a top athlete stand years of work in the home club, coaches, national team programmes, competitions and many other factors. But a camp can be an important part of this process, as it offers the athlete different partners, new knowledge, new experience and comparison with the best.',
          'Over more than three decades, many athletes who also perfected their skills at our camps later won medals at European and world championships and the Olympic Games.',
          'We are especially proud of our coastal Olympic champion Andreja Leški, who won the Olympic gold medal in Paris in 2024.',
          'Her journey carries a special message for our young people: it shows them that a child who steps onto the tatami on the Slovenian Coast today can, with talent, persistence, quality training and the right professional environment, one day reach the greatest sporting achievements.',
        ],
      },
      s5: {
        title: 'The second camp – a new generation continues the story',
        p: [
          'This continuity was also beautifully demonstrated by the second camp of this year, organised by the Judo Federation of Slovenia.',
          'The programme included senior and junior fighting training, work with younger age categories, kata learning and preparations for master grade examinations.',
          'Here too, it became clear how important the connection between generations is. Young people today gain knowledge from top competitors and coaches, who in turn continue the process that previous generations started decades ago. In this way, the experience of the past connects with modern approaches to sports training.',
          'For the first two days, the younger judoka were led by Kaja Kajzer, two-time European vice-champion, and afterwards by Olympic champion Andreja Leški.',
          'Our young members of Judo Club Izola also actively participated in the camp. For them it was a valuable sporting and educational experience, as they could train directly alongside top athletes, observe them, listen to their advice and gain new knowledge.',
          'A special moment was the meeting with Andreja Leški, with whom our young members also took photos.',
        ],
        imgCaption: 'Our young members with Olympic champion Andreja Leški.',
        after: 'This photograph beautifully symbolises the essence of our camps: today the young learn from an Olympic champion, and tomorrow perhaps they themselves will pass on their knowledge and experience to the next generation.',
      },
      s6: {
        title: 'An important success for Nina Jajić',
        p: [
          'An important educational part of the camp was also the preparation for master grade examinations.',
          'A special success was achieved by Nina Jajić, who successfully passed the exam for 1st DAN – black belt, thus moving from the school grades to the master grades of judo.',
        ],
        bold: 'With this she became the first female judo master in our club.',
        quote: 'Nina, sincere congratulations!',
        cap1: 'Taking the master grade exam in front of the committee.',
        cap2: 'Coach Jaša Babič and Nina Jajić with the diploma for 1st DAN – black belt.',
        after: 'Her success also confirms that a judo camp is not only a place of fighting training, but also a place of broader judo education, technical improvement and personal development.',
      },
      s7: {
        title: '16 days of judo and the need for further development',
        p: [
          'With this year\'s two camps, the period of organised summer judo activities in Izola has grown from the former eleven to as many as 16 days.',
          'More participants, more training sessions and more international cooperation also mean the need for better conditions.',
          'That is why the connected clubs have decided to invest in new equipment and additional tatami. We want to increase the current approximately 700 square metres of training surface to approximately 1,000 square metres.',
          'We have already raised part of the funds ourselves, and for further development we would like to invite the wider public and everyone who recognises the importance of investing in sport and youth to join us.',
        ],
        bold: 'This is not just an investment in new mats. It is an investment in more space for children, more quality training, more education, more international connections and more opportunities for future generations.',
      },
      s8: {
        title: 'We are spreading knowledge across the entire Slovenian Coast',
        p: [
          'In the future, we want to expand our work even further and connect the entire Slovenian Coast.',
          'The cooperation and work of Judo Club Izola and Judo Club Ankaran make it possible to transfer the knowledge and experience built over decades to other communities as well.',
          'Our goal is not to lock knowledge within a single club. On the contrary – we want to spread it, enrich it and create opportunities for children in Izola, Ankaran, Koper and elsewhere on the Coast.',
          'Koper already has Olympic champion Andreja Leški. Our wish is that, through good professional work and cooperation, we create conditions so that in the future top athletes can also come from Izola, Ankaran and other coastal communities.',
          'This is not a competition between municipalities over which one will produce the next Olympic champion. It is about something more important: that the entire Coast becomes an environment in which young people have the opportunity to develop their talent to the highest level.',
          'Every future European, world or Olympic medal from our Coast will therefore be a success of the wider community that enabled the young athlete to develop.',
        ],
      },
      s9: {
        title: 'After the camps, the European Junior Cup awaits us',
        p: [
          'With the conclusion of the summer camps, our joint work is far from over.',
          'Another beautiful and important part of this year\'s judo story awaits us.',
          'At the end of November, Judo Club Izola and Judo Club Impol will jointly participate in organising the European Junior Judo Cup at the Bonifika Arena in Koper.',
          'This is also important because it once again shows the strength of the cooperation between the two clubs. The cooperation we build at the camps continues in the organisation of a major international competition.',
          'From working with children and young people, through camps and education, we thus arrive at the European competitive arena.',
          'The venue also carries special symbolism. It was in this very environment that Andreja Leški trained. The dojo in which the reigning Olympic champion prepared will once again be part of the sporting action during the European Cup. Young competitors will prepare and warm up there, and then step onto the competition area of the Bonifika Arena.',
          'Next to a photograph of this space we can therefore rightfully write:',
        ],
        quote: '"The reigning Olympic champion Andreja Leški trained in this dojo."',
        after: [
          'For a young athlete, this can be a powerful message. In the same space where they prepare for their fight today, an athlete once trained who later won Olympic gold.',
          'The European Junior Cup will therefore also be a continuation of what we have been building at our camps for more than three decades: education, sports training, international cooperation, friendship and the transfer of knowledge to the young.',
        ],
      },
      s10: {
        title: 'The most important remain the children and future generations',
        p1: 'When we talk about Olympic medals, major international competitions, 1,000 square metres of tatami and a tradition of more than thirty years, we must not forget for whom we do all this.',
        bold: 'For the children and the young.',
        p: [
          'In the photographs of this year\'s camps we see children who are only just beginning their sporting journey. Beside them stand older competitors, coaches, European medallists and an Olympic champion.',
          'Decades ago, other children stood in their place. Some later became top athletes and won European, world and Olympic medals.',
          'Today, a new generation stands before us.',
          'Our responsibility is to provide it with knowledge, quality training, education, good conditions, international experience, friendship and the opportunity to progress.',
          'That is why we connect clubs, generations and municipalities. That is why we are expanding the training space. That is why we organise camps and international competitions. And that is why we pass on the knowledge we have been acquiring for more than thirty years.',
          'We cannot know which child will one day become a top athlete. But we can create an environment in which everyone gets the opportunity to develop their abilities.',
          'Perhaps among the children who train on our mats today and take photos with an Olympic champion, there is someone who will one day win the next European, world or Olympic medal.',
          'Then it will not be the success of just one athlete, one club or one municipality. It will be the success of all of us who preserved knowledge, developed it, shared it and passed it on from generation to generation.',
        ],
        quote: 'This is the story of our judo camps – a story of more than thirty years of knowledge, education, friendship and cooperation, and at the same time the story of the future of judo on the entire Slovenian Coast.',
      },
    },
    today: {
      label: 'Present',
      title: 'Judo today',
      cap1: 'The older group of adolescents.',
      cap2: 'The group of all younger and older judoka (only our youngest members are missing).',
    },
    future: {
      label: 'Future',
      title: 'Judo tomorrow',
      p1: 'The programmes we are adopting are a continuation of our work so far, to which we are adding current topics as an upgrade. These novelties are the result of our constant progress and the needs we perceive in our environment.',
      bold: 'Let us mention just some of the new contents:',
      plans: {
        lectures: {
          title: 'Lectures',
          items: [
            'We will show parents how to prepare pupils to balance school and sports training more effectively.',
            'Athlete nutrition',
            'Sports training – we are already writing professional articles, and have already published the first ones',
            'Sports competitions – especially for beginners and also for those with less knowledge',
          ],
        },
        cooperation: {
          title: 'Cooperation',
          text: 'We will cooperate more with kindergartens, schools and physical education teachers.',
        },
        education: {
          title: 'Education',
          text: 'We are gradually preparing a true educational centre on the Coast. There is a growing need for greater integration of all of us on the Coast, for closer cooperation and for a development network that would also include other experts and their knowledge.',
        },
      },
    },
    trainers: {
      label: 'Leadership',
      title: 'Our coaches',
      fb: 'Facebook profile',
      iztok: {
        name: 'Iztok Babič',
        role: 'professor of physical education and Mentor of sports training',
        desc: 'Pedagogical head of the judo sports school – has a volunteer contract with the club.',
      },
      jasa: {
        name: 'Jaša Babič',
        role: 'graduate in sports training (BSc)',
        desc: 'Head coach – contractually employed full-time by Judo Club Izola.',
      },
      mojmir: {
        name: 'Mojmir Kovač',
        role: 'level 2 coach',
        desc: 'External professional – has a volunteer contract with the club.',
      },
      oleksander: {
        name: 'Oleksander Makhovsky',
        role: 'assistant coach',
      },
    },
    recognition2: {
      label: 'Recognition',
      title: 'The professional staff of the Iztok Babič Judo Sports School led to an exceptional presentation and recognition',
      cap1: 'Presentation at the European Cadet Cup Koper 2024: Olympic champion Andreja Leški and her first coach Iztok Babič.',
      cap2: 'The young members ceremonially presented a bouquet of flowers to Olympic champion Andreja Leški at the European Cup.',
      cap3: 'Andreja Leški presented a plaque, a gift from the European Judo Union, to her former coach Iztok Babič.',
      cap4: 'The plaque with the names of all European medallists who won a medal at the Paris 2024 Olympic Games.',
    },
    social: {
      fbKlub: 'Judo Club Izola on Facebook',
      fbIztok: 'Iztok Babič on Facebook',
    },
    cta: {
      titleBefore: 'Start your ',
      titleGold: 'judo journey',
      text: 'Contact us for more information about membership and training schedules.',
      button: 'Contact us',
    },
  },
};

export default en;
